import axios from 'axios';

// 实例化 ajax请求对象
const ajaxinstance = axios.create({
  baseURL: "http://opfcontrolapi.citywavedata.com",
  timeout: 5000,
  //   headers: {
  //     'Content-Type': 'application/json',
  //   },
})

// 添加拦截器，处理 公用请求参数，和通用请求头部
ajaxinstance.interceptors.request.use(async (config) => {
    return config
}, (error) => {
  return Promise.reject(error)
})

// 请求响应拦截器
ajaxinstance.interceptors.response.use(async (response) => {
  let data = response.data
  return data;
}, (error) => {
  return Promise.reject(error)
})

export default ajaxinstance
